import React, { Component } from 'react';
import { Icon, Text } from 'evergreen-ui';

class PaginatorLink extends Component {
	constructor(props) {
		super(props);

		this.nextPage = this.nextPage.bind(this);
		this.prevPage = this.prevPage.bind(this);
	}

	nextPage = (callback) => {
		const { nextPage } = this.props;

		if (nextPage) {
			return callback;
		}

		return false;
	};

	prevPage = (callback) => {
		const { prevPage } = this.props;

		if (prevPage) {
			return callback;
		}

		return false;
	};

	render() {
		const {
			className,
			page,
			nextPage,
			prevPage,
			onclickNextPage,
			onclickPrevPage,
		} = this.props;
		return (
			<div className={className}>
				{prevPage ? (
					<Icon
						icon="caret-left"
						onClick={this.prevPage(onclickPrevPage)}
					/>
				) : (
					<Icon icon="caret-left" color="grey" />
				)}
				<Text>{page}</Text>
				{nextPage ? (
					<Icon
						icon="caret-right"
						onClick={this.nextPage(onclickNextPage)}
					/>
				) : (
					<Icon icon="caret-right" color="grey" />
				)}
			</div>
		);
	}
}

export default PaginatorLink;
